module.exports = __webpack_public_path__ + "static/media/teygja_axlir_a.420fd144.png";